import { type CountryCode } from 'libphonenumber-js';

/**
 * Map between the dropdown's full country names and libphonenumber ISO codes.
 * Bidirectional so we can both seed parsing with the current country and flip
 * the dropdown when the parsed number resolves to a different one.
 *
 * Lives here (rather than in useCustomerForm) so section components can
 * import it without creating a circular dependency back into the hook.
 */
export const COUNTRY_NAME_TO_ISO: Record<string, CountryCode> = {
  'United States': 'US',
  'Canada': 'CA',
};

export const ISO_TO_COUNTRY_NAME: Record<string, string> = Object.fromEntries(
  Object.entries(COUNTRY_NAME_TO_ISO).map(([name, iso]) => [iso, name]),
);

/**
 * Split a single name into first/last on the first space. Used to derive
 * the billing name from customer.name (Individual mode, override off) and
 * to seed billing fields when the override checkbox is enabled.
 */
export function splitName(name: string): { first: string; last: string } {
  const trimmed = (name || '').trim();
  const i = trimmed.indexOf(' ');
  return i === -1
    ? { first: trimmed, last: '' }
    : { first: trimmed.slice(0, i), last: trimmed.slice(i + 1).trim() };
}
